import CompanyModel                from 'Models/directory/CompanyModel';
import CountryCompanyPropertyModel from 'Models/directory/CountryCompanyPropertyModel';
import doc                         from 'decorators/doc';
import model                       from 'decorators/model';
import { Timestampable }           from 'helpers/traits';
import { Blamable }                from 'helpers/traits';
import DirectoryPrivateApiModel    from 'modelx/models/abstracts/DirectoryPrivateApiModel';

@model.staticLabel('CompanyCountryCompanyProperty')
@model.urnResource('company_country_company_property')
@doc.path('/company_country_company_properties/{?id}')
export default class CompanyCountryCompanyPropertyModel extends Blamable(Timestampable(DirectoryPrivateApiModel)) {
	public _filters: ModelFiltersExtended<{
		'company': id;
		'company.enterprise.country': id;
		'countryCompanyProperty': id;
		'countryCompanyProperty.companyProperty': id;
		'countryCompanyProperty.companyProperty.reference': DirectoryCompanyPropertyReference;
		'countryCompanyProperty.country': id;
		'value': id;
	}> = {};

	public _sorts: ModelSortsExtended<unknown> = {};

	@doc.model(CompanyModel) declare company: CompanyModel;
	@doc.model(CountryCompanyPropertyModel) declare countryCompanyProperty: CountryCompanyPropertyModel;
	@doc.string declare value: string;
}